/**
 * Build Notes List deep link URLs from Cuelist project context.
 */
import { NOTESLIST_APP_URL } from '@/lib/URLs';
import addNoteParams from '@/lib/lxnotes-link-params';

const TAB_NAME = 'noteslist-linked-production';

export function buildAddNoteUrl(productionId, link = {}) {
    if (!productionId) {
        return null;
    }
    const base = (process.env.VUE_APP_NOTESLIST_APP_URL || NOTESLIST_APP_URL).replace(/\/$/, '');
    const params = addNoteParams(link);
    return `${base}/production/${encodeURIComponent(productionId)}/cue-notes?${params.toString()}`;
}

export function openAddNoteUrl(productionId, cue) {
    const url = buildAddNoteUrl(productionId, {
        cuelistCueId: cue && cue.id,
        cueLabel: cue && cue.title,
        cuelistLayerId: cue && cue.layer
    });
    if (!url) {
        return;
    }
    window.open(url, TAB_NAME);
}

export function buildProductionUrl(productionId) {
    if (!productionId) {
        return null;
    }
    const base = (process.env.VUE_APP_NOTESLIST_APP_URL || NOTESLIST_APP_URL).replace(/\/$/, '');
    return `${base}/production/${encodeURIComponent(productionId)}/cue-notes`;
}

export function openProductionUrl(productionId) {
    const url = buildProductionUrl(productionId);
    if (!url) {
        return;
    }
    window.open(url, TAB_NAME);
}

export default {
    buildAddNoteUrl,
    openAddNoteUrl,
    buildProductionUrl,
    openProductionUrl,
    TAB_NAME
};


// WEBPACK FOOTER //
// ./src/lib/lxnotes-links.js